import React, { useState } from 'react';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { copyright, copyrightParams, info } from '../../../constants/copyright';
import { safeHTML } from '../../../utils/safeHTML';
import useStateControls from '../../../hooks/useStateControls';
import useCustomBridge from '../../../hooks/useCustomBridge';
import CustomBridge from '../../../controllers/bridge/CustomBridge';
import Room from '../../features/room/Room';
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData';
import { usePreloadPromises } from '../../../hooks/usePreloadPromises';
import { GTMSignUp } from '../../../constants/analytics/GTM';
import AppLoader from '../../features/appLoader/AppLoader';
import { useTranslation } from '../../../translations';
import { START } from '../../../constants/shared/states/names';
import { useModal } from '../../../hooks/useModal';

const { text, button } = info;

const Info = React.forwardRef(function (_, ref) {
  const { t } = useTranslation();
  const { addModal } = useModal();
  const { setState } = useStateControls();

  const [isPreloadPending, setIsPreloadPending] = useState(false);

  const preloadPromises = usePreloadPromises({
    fulfilled: () => {
      console.log('GA TMG [Info] 🎉 Загрузка завершена, переход на START');
      setIsPreloadPending(false);
      setState(START);
    },
  });

  useCustomBridge();

  const isAuthPending = useRequestsHandlerData([
    {
      address: 'requestsUserAuth',
      fulfilled(payload) {
        if (payload?.isGameStopped) {
          setIsPreloadPending(false);
          addModal({
            type: 'inactiveAppModal',
          });
        } else {
          setIsPreloadPending(true);
          preloadPromises();
          GTMSignUp();
        }
      },
      rejected() {
        setIsPreloadPending(false);

        CustomBridge.instance.send({
          name: 'SHOW_NOTIFICATION',
          type: 0,
          data: {
            hasCloseButton: false,
            text: t('auth.notification.error'),
          }
        })
      },
    },
  ]);

  const showAppLoader = isAuthPending || isPreloadPending;

  const toAuth = () => {
    if (showAppLoader) return; // предотвращает повторные клики

    CustomBridge.instance.send({ name: 'AUTH', type: 0 })
  };

  return (
    <section className={'info'} ref={ref}>
      <div className={'info__content'}>
        <div className={'info__room-wrapper'}>
          <Room />
        </div>
        <div className={'info__block'}>
          <div className={'info__text'}>{safeHTML(t(text))}</div>
          <CustomButton {...button} onClick={toAuth} />
          <p className={'info__copyright'}>{safeHTML(t(copyright, copyrightParams))}</p>
        </div>
      </div>

      {showAppLoader && <AppLoader />}
    </section>
  );
});
export default Info;
